import React, { useContext, useEffect, useState } from "react";
import "./Blogs_Section.css";
import { useNavigate } from "react-router-dom";
import { getAllBlog } from "../../../utils/apis/blog/Homeapi";
import { encodeId, timeAgo, timeAgoOrDate } from "../../../utils/common";
import { Context } from "../../../utils/context";

const Blogs_Section = () => {


  const {
    IMG_URL,
    appSetup
  } = useContext(Context);
  const navigate = useNavigate();

  const handleBlogClick = (blog) => {
    navigate(`/blog/${encodeId(blog.id)}`);
  };
  const blogData = [
    {
      id: 1,
      image: "/assets/images/home/blog_section/img-1.png",
      title: "A Variety of Safe Taxi Services on Your Way",
      desc:
        "Lorem Ipsum is simply dummy text of the printing & typesetting industry.",
      // date: "2 hrs ago",
    },
    {
      id: 2,
      image: "/assets/images/home/blog_section/img-2.png",
      title: "A Variety of Safe Taxi Services on Your Way",
      desc:
        "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
      date: "30/01/2026",
    },
    {
      id: 3,
      image: "/assets/images/home/blog_section/img-3.png",
      title: "A Variety of Safe Taxi Services on Your Way",
      desc:
        "Lorem Ipsum is simply dummy text of the printing & typesetting industry.",
      date: "25/01/2026",
    },
  ];


  const [blogs, setBlogs] = useState();
  const getAllBlogs = async () => {
    const res = await getAllBlog({});

    if (res?.success) {
      setBlogs(res?.data);
    } else {
      console.error('Error fetching  data:', res?.error);
    }
  }

  useEffect(() => {
    getAllBlogs();
  }, []);
  return (
    <section className="Blogs_Section">
      <div className="container">
        <div className="Blogs_Section_heading text-center">
          <p className="blogs_title">Blogs</p>
          <h5 className="blogs_subtitle">Stay Updated with Us!</h5>
        </div>

        <div className="blog_cards_section">
          <div className="row mt-5">
            {blogs?.data?.slice(0, 3)?.map((blog) => (
              <div
                className="col-lg-4 col-md-6 col-sm-6 mb-3  d-flex"
                key={blog.id}
              >
                <div
                  className="blogs_card  w-100"
                  onClick={() => handleBlogClick(blog)}
                >
                  <div className="blog_img_wrapper">
                    <img
                      src={IMG_URL + blog.image}
                      alt={blog.title}
                      className="blog_img"
                    />
                  </div>
                  <div className="blog_body">
                    <h5 className="blogs_card_title">{blog.blog_name || ""}</h5>
                    <p className="blogs_card_desc">{blog.name || ""}</p>

                    <div className="blog_footer">
                      <span className="blog_date">{timeAgoOrDate(blog.createdAt)}</span>
                      <p className="blog_read_btn">Start Reading</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="view_all_div" onClick={() => navigate("/tour-packages")}>
            <p className="VIEW_MORE">VIEW MORE</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blogs_Section;
